import React from 'react';
import { useDispatch } from 'react-redux';
import Link from 'housecall-ui/dist/DesignSystem/Navigation/Link/Link';
import PropTypes from 'prop-types';

import { trackButtonClicked } from '../../Services/Analytics/TrackEventsService';

const DeprecatedTrackedLink = ({ trackingName, trackingProperties = {}, ...rest }) => {
  const dispatch = useDispatch();

  return (
    <Link
      data-testid="tracked-link"
      onClick={() => dispatch(trackButtonClicked(trackingName, trackingProperties))}
      {...rest}
    />
  );
};

DeprecatedTrackedLink.propTypes = {
  trackingName: PropTypes.string.isRequired,
  trackingProperties: PropTypes.shape({}),
};

export default DeprecatedTrackedLink;
